
import React from 'react'

//Initializes a react context
const UserContext = React.createContext()

//Provides  a specific contact through components

export const UserProvider = UserContext.Provider


export default UserContext 

	